import type React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import './Disclaimer.css';

const Disclaimer: React.FC = () => {
  const { t } = useTranslation();

  const items = [
    {
      label: t('disclaimer.representativeLabel', 'Representative Nature:'),
      text: t('disclaimer.representativeText'),
    },
    {
      label: t('disclaimer.notRulingLabel', 'Not a Religious Ruling:'),
      text: t('disclaimer.notRulingText'),
    },
    {
      label: t('disclaimer.hallucinationLabel', 'Margin of Error (Hallucination):'),
      text: t('disclaimer.hallucinationText'),
    },
    {
      label: t('disclaimer.chronologicalLabel', 'Chronological Inconsistencies:'),
      text: t('disclaimer.chronologicalText'),
    },
    { label: t('disclaimer.modernLabel', 'Modern Concepts:'), text: t('disclaimer.modernText') },
    { label: t('disclaimer.styleLabel', 'Style Limitations:'), text: t('disclaimer.styleText') },
    { label: t('disclaimer.disclaimerLabel', 'Disclaimer:'), text: t('disclaimer.disclaimerText') },
  ];

  return (
    <div className="disclaimer-page">
      <div className="bg-accent-shape" />
      <Header />

      <main className="disclaimer-main">
        <section className="disclaimer-hero">
          <div className="disclaimer-hero-content">
            <div className="hero-line" />
            <h2 className="hero-label">{t('terms.heroLabel', 'Legal')}</h2>
            <div className="hero-line" />
          </div>
          <h1 className="hero-title">{t('disclaimer.title', 'Disclaimer')}</h1>
        </section>

        <section className="disclaimer-content">
          <p className="disclaimer-intro-text">{t('disclaimer.intro')}</p>

          <div className="disclaimer-items">
            {items.map((item) => (
              <div key={item.label} className="disclaimer-page-item">
                <span className="disclaimer-page-label">{item.label}</span>
                <span className="disclaimer-page-text"> {item.text}</span>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Disclaimer;
